import React, { useState, useEffect } from 'react';

const QuizzOption = ({ id, label, image, checked, onOptionSelect, selectedOptionId }) => {

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <div className={`quizz-option${image ? " quizz-option--img" : ""}${checked ? " checked" : ""}${selectedOptionId ? "" : " animated"}${visible ? " visible": ""}`}>
            <div className="quizz-option__container">
                <input 
                    id={id} 
                    type="radio" 
                    value={label} 
                    name={id} 
                    checked={checked}
                    onChange={() => onOptionSelect(id)} />
                <label htmlFor={id}>
                    {image &&
                        <div className="quizz-option__image" style={{backgroundImage: `url(${image})`}}></div>
                    }
                    <div className={`quizz-option__text${!image && label.length > 15 ? " quizz-option__text--small" : ""}`}>
                        <span>{label}</span>
                    </div>
                </label>
            </div>
        </div>
    );
};

export default QuizzOption;

